function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 32",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22.3 17.6L1.95 31.5C1 32.2-.1 31 .1 29.55l1.7-11.4 12.65-1.85c.4-.1.4-.6 0-.65L1.8 13.8.1 2.4C-.1.95 1-.25 1.95.4L22.3 14.3c.95.75.95 2.65 0 3.3z"
}));